import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import InstructionAudioListFilter from './InstructionAudioListFilter';
import InstructionAudioListService from '../services/InstructionAudioListService';

class InstructionAudioListFilterContainer extends React.Component {
  static propTypes = {
    initialFilters: PropTypes.object,
  };

  static defaultProps = {
    initialFilters: null,
  };

  componentDidMount() {
    InstructionAudioListService.init(this.props.initialFilters);
  }

  render() {
    return (
      <InstructionAudioListFilter
        values={InstructionAudioListService.form.getValues()}
        onChange={InstructionAudioListService.form.setValue}
        fetching={InstructionAudioListService.fetch.fetching}
        onSearch={InstructionAudioListService.handleLoad}
      />
    );
  }
}

export default observer(InstructionAudioListFilterContainer);
